import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n'
import Root from './containers/Root'
import configureStore from './redux/configureStore'

import translationsObject from './Application/lang/langs'
import Constants from './Application/services/constants/Constants'
import resetStore from './Application/ApplicationConfigureStore'

const history = createBrowserHistory()

let store
console.log(process.env.NODE_ENV)
// if (process.env.NODE_ENV !== 'local' && window.location.protocol !== 'https:') {
//   let href = window.location.href
//   href = href.replace('http://', 'https://')
//   window.location.href = href
// }

if (window.performance) {
  let initialStateStore = {}
  window.addEventListener('DOMContentLoaded', function (event) {
    let timing = performance.timing.domContentLoadedEventStart - performance.timing.navigationStart
    console.log('Loading time: ' + timing + 'ms')
  })

  if (performance.navigation.type === 1) {
    if (localStorage.getItem('appStore')) initialStateStore = JSON.parse(localStorage.getItem('appStore'))
    /* reset parts of store when reloading */
    initialStateStore = resetStore(initialStateStore)
  } else {
    localStorage.removeItem('selectedMenuItem')
  }

  const initialState = initialStateStore
  store = configureStore({ history, initialState })
  store.subscribe(function save() {
    localStorage.setItem('appStore', JSON.stringify(store.getState()))
  })
} else {
  const initialState = {}
  store = configureStore({ initialState })
}

// i18n
let lang = window.navigator.languages ? window.navigator.languages[0] : null
lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage
if (lang.indexOf('-') !== -1) {
  lang = lang.split('-')[0]
}

if (lang.indexOf('_') !== -1) {
  lang = lang.split('_')[0]
}

let langFounded = false
Constants.langs.forEach((item) => {
  if (item === lang) langFounded = true
})

syncTranslationWithStore(store)
store.dispatch(loadTranslations(translationsObject))
store.dispatch(setLocale(langFounded ? lang : 'en'))

// Coachmark
if (!localStorage.getItem('coach')) localStorage.setItem('coach', '[]')

// Render the React application to the DOM
ReactDOM.render(
  <Root history={history} store={store} />,
  document.getElementById('root')
)
